import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SwiperModule } from 'swiper/angular';
import { ImageTitleModule } from '@studiobuki/web-core/lib/image-title';
import { SectionProductsComponent } from './section-products.component';
import { ProductModule } from '../product/product.module';
import { ItemsComponent } from './components/items/items.component';
import { CarouselComponent } from './components/carousel/carousel.component';
import { ProductComponent } from './components/item/item.component';

@NgModule({
  declarations: [
    SectionProductsComponent,
    ItemsComponent,
    CarouselComponent,
    ProductComponent,
  ],
  imports: [CommonModule, ImageTitleModule, ProductModule, SwiperModule],
  exports: [SectionProductsComponent, CarouselComponent],
})
export class SectionProductsModule {}
